import {
  FieldValues,
  Resolver,
  useForm,
  UseFormProps,
  UseFormReturn,
} from 'react-hook-form';
import { z } from 'zod';

import { zodResolver } from '@hookform/resolvers/zod';

export function useAppForm<TSchema extends z.ZodType<FieldValues>>(
  schema: TSchema,
  options?: Omit<UseFormProps<z.infer<TSchema>>, 'resolver'>,
): UseFormReturn<z.infer<TSchema>> {
  type FormValues = z.infer<TSchema>;

  return useForm<FormValues>({
    ...options,
    mode: 'onChange',
    // Zod v4 and @hookform/resolvers have type incompatibility; runtime works correctly
    resolver: zodResolver(
      schema as Parameters<typeof zodResolver>[0],
    ) as unknown as Resolver<FormValues>,
  });
}
